import { useFormikContext } from 'formik';
import { useId, type ComponentProps } from 'react';

import { ReactSelectTimezones } from 'hb-react/shared/components/ReactSelect';

export const TimezoneSelect = ({
  name,
  label,
  ...props
}: ComponentProps<typeof ReactSelectTimezones> & {
  label: string;
  name: string;
}) => {
  const { values, setFieldValue } = useFormikContext<{
    [key: string]: Array<number>;
  }>();
  const id = useId();

  return (
    <ReactSelectTimezones
      id={id}
      required
      name={name}
      label={label}
      onChange={(value: { id: string; name: string; tzinfo_name: string }) => {
        setFieldValue(name, value.tzinfo_name);
      }}
      value={values[name]}
      {...props}
    />
  );
};
